import { render } from "./LeaveListTable.vue?vue&type=template&id=506eafa3&scoped=true"
import script from "./LeaveListTable.vue?vue&type=script&lang=js"
export * from "./LeaveListTable.vue?vue&type=script&lang=js"

import "./LeaveListTable.vue?vue&type=style&index=0&id=506eafa3&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-506eafa3"]])

export default __exports__